import { memo } from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import classnames from 'classnames';

import styles from './DisabledButton.scss';

export const DisabledButton = memo(({ children, className, ...props }) => (
  <div
    role="button"
    aria-disabled="true"
    className={classnames(styles.DisabledButton, className)}
    {...props}
  >
    {children}
  </div>
));

DisabledButton.displayName = 'DisabledButton';

DisabledButton.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  className: string,
};
